module.exports = __webpack_public_path__ + "img/maison2.ffa8eadd.jpg";